// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0
/**
 * A helper to store the snack bar informations in a way svelte can react on from any component and script
 */
import { writable } from 'svelte/store';

export const snackbarStore = writable({
  snackbarOpen: false,
  snackbarMessage: '',
  snackbarSeverity: 'error', // can be error, confirmation, success
});
